var map = {
	"./icon_animal_plants.svg": 2899,
	"./icon_artmedia.svg": 2900,
	"./icon_beautyfashion.svg": 2901,
	"./icon_biochem.svg": 2902,
	"./icon_communication.svg": 2903,
	"./icon_construction.svg": 2904,
	"./icon_finance.svg": 2905,
	"./icon_food.svg": 2906,
	"./icon_health.svg": 2907,
	"./icon_house.svg": 2908,
	"./icon_language.svg": 2909,
	"./icon_mechatronics.svg": 2910,
	"./icon_metal.svg": 2911,
	"./icon_outside.svg": 2912,
	"./icon_programming.svg": 2913,
	"./icon_service.svg": 2914,
	"./icon_social.svg": 2915,
	"./icon_sports.svg": 2916,
	"./icon_stone_wood.svg": 2917,
	"./icon_sustainable.svg": 2918,
	"./icon_tourism.svg": 2919,
	"./icon_trade.svg": 2920,
	"./icon_transport.svg": 2921,
	"./icon_vehicles.svg": 2922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2898;